<template lang="pug">
  .main-page__banner.banner-block
    .banner-block__style(v-html="style")
    .banner-block__content(v-html="html")
</template>
<script>
export default {
  props: {
    html: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    style () {
      return `<style>${this.css}</style>`
    }
  }
}
</script>
